module.exports = __webpack_public_path__ + "static/media/galeryFloating6.f4d2a6ea.jpg";